"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHover = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectSpread5 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = require("react");
var getInitialEmptyHover = function getInitialEmptyHover(data) {
  return data.reduce(function (accumulator, _, index) {
    return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, accumulator), {}, (0, _defineProperty2.default)({}, index, undefined));
  }, {});
};
var useHover = function useHover(data) {
  var _useState = (0, _react.useState)(function () {
      return getInitialEmptyHover(data);
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hoveredIndexDictionary = _useState2[0],
    setHoveredIndexDictionary = _useState2[1];
  var onMouseEnterFactory = (0, _react.useCallback)(function (sectionIndex, dataIndex) {
    return function () {
      setHoveredIndexDictionary(function (_hoveredIndexDictionary) {
        return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, _hoveredIndexDictionary), {}, (0, _defineProperty2.default)({}, sectionIndex, dataIndex));
      });
    };
  }, []);
  var onMouseLeaveFactory = (0, _react.useCallback)(function (sectionIndex, dataIndex) {
    return function () {
      setHoveredIndexDictionary(function (_hoveredIndexDictionary) {
        var leftElementState = _hoveredIndexDictionary[dataIndex];
        return (0, _objectSpread5.default)((0, _objectSpread5.default)({}, _hoveredIndexDictionary), {}, (0, _defineProperty2.default)({}, sectionIndex, leftElementState !== undefined ? undefined : leftElementState));
      });
    };
  }, []);
  var isHovered = function isHovered(sectionIndex, dataIndex) {
    return hoveredIndexDictionary[sectionIndex] === dataIndex;
  };
  return {
    onMouseEnterFactory: onMouseEnterFactory,
    onMouseLeaveFactory: onMouseLeaveFactory,
    isHovered: isHovered
  };
};
exports.useHover = useHover;